module.exports = __webpack_public_path__ + "img/apartment-blue.f059f062.png";